// Array of layers with statistics attached.
export var UNTD_LAYERS = [{
  id: "zip",
  label: "UI_MAP_LAYERS_ZIPS",
  types: ["polygons"],
  tooltip: null,
  only_one: true,
  only_one_name: "basic_geo",
  group: 0,
  index: 1,
  place_type: "Zip",
  popup: 1,
  id_key: 'GEOID',
  label_key: 'GEOID',
  type_label_key: "UI_MAP_FEATURE_ZIP"
}, {
  id: "tract",
  label: "UI_MAP_LAYERS_TRACTS",
  types: ["polygons"],
  tooltip: null,
  only_one: true,
  only_one_name: "basic_geo",
  group: 0,
  index: 2,
  place_type: "Tract",
  popup: 1,
  id_key: 'GEOID',
  label_key: 'NAME',
  type_label_key: "UI_MAP_FEATURE_TRACT"
}, {
  id: "place",
  label: "UI_MAP_LAYERS_PLACES",
  types: ["polygons"],
  tooltip: null,
  only_one: true,
  only_one_name: "basic_geo",
  group: 0,
  index: 3,
  place_type: "Place",
  popup: 1,
  id_key: 'GEOID',
  label_key: 'NAME',
  type_label_key: "UI_MAP_FEATURE_PLACE"
}]; // Static layers without statistics attached.

export var UNTD_STATIC_LAYERS = [{
  id: "none",
  label: "UI_MAP_LAYERS_NONE",
  types: [],
  tooltip: null,
  only_one: true,
  only_one_name: "static_geo",
  group: 0,
  index: 0,
  place_type: "",
  has_labels: 0,
  label_key: 'STATIC_LAYER_NONE'
}, {
  id: "county",
  label: "UI_MAP_LAYERS_COUNTIES",
  types: ["polygons"],
  tooltip: null,
  only_one: true,
  only_one_name: "static_geo",
  group: 0,
  index: 0,
  place_type: "County",
  has_labels: 0,
  label_key: 'NAME'
}, {
  id: "fedcongress",
  label: "UI_MAP_FEATURE_FEDCONGRESS",
  types: ["polygons"],
  tooltip: null,
  only_one: true,
  only_one_name: "static_geo",
  group: 0,
  index: 0,
  place_type: "label",
  has_labels: 1,
  label_key: 'Official'
}, {
  id: "statehouse",
  label: "UI_MAP_FEATURE_STATEHOUSE",
  types: ["polygons"],
  tooltip: null,
  only_one: true,
  only_one_name: "static_geo",
  group: 0,
  index: 0,
  place_type: "label",
  has_labels: 1,
  label_key: 'Official'
}, {
  id: "statesenate",
  label: "UI_MAP_FEATURE_STATESENATE",
  types: ["polygons"],
  tooltip: null,
  only_one: true,
  only_one_name: "static_geo",
  group: 0,
  index: 0,
  place_type: "label",
  has_labels: 1,
  label_key: 'Official'
}, {
  id: "schooldistricts",
  label: "UI_MAP_FEATURE_SCHOOLDISTRICTS",
  types: ["polygons"],
  tooltip: null,
  only_one: true,
  only_one_name: "static_geo",
  group: 0,
  index: 0,
  place_type: "label",
  has_labels: 1,
  label_key: 'NAME'
}];
export var POINT_CATEGORIES = [{
  id: "social_infrastructure",
  subcategories: [],
  color: "rgba(154,85,142,1)"
}, {
  id: "commerce",
  subcategories: [],
  color: "rgba(73,81,94,1)"
}, {
  id: "school",
  subcategories: ['public_school', 'private_school', 'charter_school'],
  color: "rgba(145,75,13,1)"
}, {
  id: "public_health",
  subcategories: [],
  color: "rgba(219,134,48,1)"
}];
export var BREAKPOINTS = [{
  id: 'xs',
  max: 0
}, {
  id: 'sm',
  max: 320
}, {
  id: 'md',
  max: 768
}, {
  id: 'lg',
  max: 992
}, {
  id: 'xl',
  max: 1280
}];